// src/data/routeData.js
// Central config for all 20 high-traffic SEO route pages

export const ROUTE_PAGES = [
  {
    slug: "junagadh-to-somnath-cab",
    from: "Junagadh",
    to: "Somnath",
    fromState: "Gujarat",
    toState: "Gujarat",
    distance: "85 km",
    duration: "1 hr 30 min",
    price: "₹5,250",
    isAirport: false,
    description:
      "Book a comfortable cab from Junagadh to Somnath with Halo Sorath. Visit the famous Somnath Jyotirlinga temple with professional drivers and affordable rates.",
    highlights: [
      "One-way & round-trip available",
      "AC & Non-AC cabs",
      "Professional verified drivers",
      "No hidden charges",
    ],
    popularFor:
      "Somnath is one of the 12 sacred Jyotirlinga temples in India, making this a popular pilgrimage route from Junagadh.",
    seoTitle:
      "Junagadh to Somnath Cab | Book Taxi ₹5,250 | Halo Sorath",
    seoDescription:
      "Book Junagadh to Somnath cab at ₹5,250. 85 km, 1.5 hrs. Comfortable AC taxi with professional drivers. One-way & round-trip. Call Halo Sorath 24×7.",
    landmarks: ["Somnath Jyotirlinga Temple", "Bhalka Tirth", "Somnath Beach", "Prabhas Patan Museum"],
  },
  {
    slug: "junagadh-to-dwarka-cab",
    from: "Junagadh",
    to: "Dwarka",
    fromState: "Gujarat",
    toState: "Gujarat",
    distance: "245 km",
    duration: "4 hrs 15 min",
    price: "₹5,250",
    isAirport: false,
    description:
      "Book Junagadh to Dwarka cab service with Halo Sorath. Comfortable one-way and round-trip taxi for the sacred Dwarkadheesh temple pilgrimage.",
    highlights: [
      "Direct non-stop service",
      "Comfortable AC sedans & SUVs",
      "Pilgrimage-friendly drivers",
      "Affordable flat rates",
    ],
    popularFor:
      "Dwarka is one of the Char Dham pilgrimage sites. This route is popular among devotees traveling from Junagadh for the Dwarkadheesh temple.",
    seoTitle:
      "Junagadh to Dwarka Cab | Book Taxi ₹5,250 | Halo Sorath",
    seoDescription:
      "Book Junagadh to Dwarka cab at ₹5,250. 245 km, 4+ hrs. AC taxi with professional pilgrimage drivers. One-way & round-trip. Halo Sorath 24×7.",
    landmarks: ["Dwarkadheesh Temple", "Nageshwar Jyotirlinga", "Rukmini Temple", "Gomti Ghat"],
  },
  {
    slug: "junagadh-to-diu-cab",
    from: "Junagadh",
    to: "Diu",
    fromState: "Gujarat",
    toState: "Diu (UT)",
    distance: "110 km",
    duration: "2 hrs",
    price: "₹5,250",
    isAirport: false,
    description:
      "Book Junagadh to Diu cab at the best price. Enjoy the scenic coastal drive to Diu island with comfortable AC taxis and professional drivers from Halo Sorath.",
    highlights: [
      "Scenic coastal route",
      "AC & Non-AC options",
      "On-time guaranteed",
      "No surge pricing",
    ],
    popularFor:
      "Diu is a popular beach destination and Union Territory known for Portuguese heritage, beaches, and nightlife, making it a top weekend getaway from Junagadh.",
    seoTitle:
      "Junagadh to Diu Cab | Book Taxi ₹5,250 | Halo Sorath",
    seoDescription:
      "Book Junagadh to Diu cab at ₹5,250. 110 km, 2 hrs. Scenic coastal taxi with professional drivers. One-way & round-trip available. Call Halo Sorath.",
    landmarks: ["Diu Fort", "Nagoa Beach", "INS Khukri Memorial", "St. Paul's Church"],
  },
  // {
  //   slug: "junagadh-to-gir-cab",
  //   from: "Junagadh",
  //   to: "Gir",
  //   fromState: "Gujarat",
  //   toState: "Gujarat",
  //   distance: "60 km",
  //   duration: "1 hr 15 min",
  //   price: "₹5,250",
  //   isAirport: false,
  //   description:
  //     "Book Junagadh to Gir National Park cab with Halo Sorath. The most affordable and reliable way to reach the last home of Asiatic lions.",
  //   highlights: [
  //     "Nearest pick-up to Gir",
  //     "Early morning safari drops",
  //     "Luggage-friendly vehicles",
  //     "Return trips available",
  //   ],
  //   popularFor:
  //     "Gir National Park is the only habitat of wild Asiatic lions. It's a top wildlife destination for tourists from Junagadh and across India.",
  //   seoTitle:
  //     "Junagadh to Gir Cab | Book Taxi ₹5,250 | Halo Sorath",
  //   seoDescription:
  //     "Book Junagadh to Gir National Park cab at ₹5,250. 60 km, 1.15 hrs. Early morning safari drops available. Professional drivers. Call Halo Sorath.",
  //   landmarks: ["Gir National Park & Sanctuary", "Devaliya Safari Park", "Sinh Sadan", "Kamleshwar Dam"],
  // },
  {
    slug: "junagadh-to-rajkot-cab",
    from: "Junagadh",
    to: "Rajkot",
    fromState: "Gujarat",
    toState: "Gujarat",
    distance: "105 km",
    duration: "1 hr 45 min",
    price: "₹5,250",
    isAirport: false,
    description:
      "Book Junagadh to Rajkot cab with Halo Sorath. Fast, comfortable, and affordable taxi service between two major Gujarat cities with verified professional drivers.",
    highlights: [
      "Fastest intercity route",
      "Business & leisure travel",
      "Corporate billing available",
      "AC sedans & SUVs",
    ],
    popularFor:
      "Rajkot is a major commercial hub in Saurashtra. This is a high-demand business travel route connecting Junagadh to Rajkot's markets, hospital, and airport.",
    seoTitle:
      "Junagadh to Rajkot Cab | Book Taxi ₹5,250 | Halo Sorath",
    seoDescription:
      "Book Junagadh to Rajkot cab at ₹5,250. 105 km, 1.45 hrs. Fastest intercity taxi. Corporate billing available. Halo Sorath 24×7 support.",
    landmarks: ["Rajkot Race Course", "Jubilee Garden", "Watson Museum", "Rajkot Airport"],
  },
  {
    slug: "rajkot-to-somnath-cab",
    from: "Rajkot",
    to: "Somnath",
    fromState: "Gujarat",
    toState: "Gujarat",
    distance: "190 km",
    duration: "3 hrs",
    price: "₹5,250",
    isAirport: false,
    description:
      "Book Rajkot to Somnath cab with Halo Sorath. Comfortable pilgrimage taxi service to the sacred Somnath Jyotirlinga temple with experienced drivers.",
    highlights: [
      "Pilgrimage-specialist drivers",
      "One-way & round-trip",
      "Spacious SUV options",
      "Transparent pricing",
    ],
    popularFor:
      "Somnath Jyotirlinga is a major pilgrimage site. Rajkot is a major departure city for devotees across Saurashtra visiting this sacred shrine.",
    seoTitle:
      "Rajkot to Somnath Cab | Book Taxi ₹5,250 | Halo Sorath",
    seoDescription:
      "Book Rajkot to Somnath cab at ₹5,250. 190 km, 3 hrs. Pilgrimage taxi with professional drivers. One-way & round-trip. Halo Sorath 24×7.",
    landmarks: ["Somnath Jyotirlinga Temple", "Bhalka Tirth", "Triveni Sangam", "Somnath Beach"],
  },
  {
    slug: "rajkot-to-dwarka-cab",
    from: "Rajkot",
    to: "Dwarka",
    fromState: "Gujarat",
    toState: "Gujarat",
    distance: "220 km",
    duration: "3 hrs 30 min",
    price: "₹5,250",
    isAirport: false,
    description:
      "Book Rajkot to Dwarka cab with Halo Sorath. Reliable AC taxi for the Char Dham pilgrimage route with experienced and courteous drivers.",
    highlights: [
      "Char Dham pilgrimage route",
      "Multiple vehicle types",
      "Driver wait service",
      "Night travel available",
    ],
    popularFor:
      "Dwarka is one of India's most sacred cities and Char Dham sites. It is a top pilgrimage destination from Rajkot.",
    seoTitle:
      "Rajkot to Dwarka Cab | Book Taxi ₹5,250 | Halo Sorath",
    seoDescription:
      "Book Rajkot to Dwarka cab at ₹5,250. 220 km, 3.5 hrs. Char Dham pilgrimage taxi. Professional drivers. One-way & round-trip. Halo Sorath.",
    landmarks: ["Dwarkadheesh Temple", "Bet Dwarka", "Nageshwar Jyotirlinga", "Lighthouse"],
  },
  {
    slug: "rajkot-to-diu-cab",
    from: "Rajkot",
    to: "Diu",
    fromState: "Gujarat",
    toState: "Diu (UT)",
    distance: "215 km",
    duration: "3 hrs 30 min",
    price: "₹5,250",
    isAirport: false,
    description:
      "Book Rajkot to Diu cab with Halo Sorath. Enjoy a comfortable road trip to Diu's beaches and Portuguese heritage with affordable AC taxi service.",
    highlights: [
      "Beach & leisure trips",
      "Family-friendly vehicles",
      "Return trips available",
      "Child seat on request",
    ],
    popularFor:
      "Diu is the top beach and leisure destination for Rajkot residents seeking a coastal getaway on the Arabian Sea.",
    seoTitle:
      "Rajkot to Diu Cab | Book Taxi ₹5,250 | Halo Sorath",
    seoDescription:
      "Book Rajkot to Diu cab at ₹5,250. 215 km, 3.5 hrs. Beach getaway taxi with family-friendly vehicles. Halo Sorath 24×7 support.",
    landmarks: ["Diu Fort", "Nagoa Beach", "Ghoghla Beach", "St. Paul's Church"],
  },
  {
    slug: "rajkot-airport-taxi",
    from: "Rajkot",
    to: "Rajkot Airport",
    fromState: "Gujarat",
    toState: "Gujarat",
    distance: "City-wide",
    duration: "Varies",
    price: "₹500 onwards",
    isAirport: true,
    description:
      "Book Rajkot Airport taxi with Halo Sorath. Reliable airport pickup and drop service from all Rajkot locations with flight-tracking and on-time guarantee.",
    highlights: [
      "Flight tracking included",
      "Meet & greet at terminal",
      "24×7 airport service",
      "Fixed rates, no surge",
    ],
    popularFor:
      "Rajkot Airport (RAJ) serves Saurashtra region. Halo Sorath offers the most trusted airport transfer service in Rajkot with pre-booked fixed rates.",
    seoTitle:
      "Rajkot Airport Taxi | Book Airport Cab | Halo Sorath",
    seoDescription:
      "Book Rajkot Airport taxi with Halo Sorath. Flight tracking, meet & greet, 24×7 service. Fixed rates from ₹500. Reliable airport transfer in Rajkot.",
    landmarks: ["Rajkot Airport (RAJ)", "City Centre", "Race Course Road", "Gondal Road"],
  },
  // {
  //   slug: "rajkot-to-gir-cab",
  //   from: "Rajkot",
  //   to: "Gir",
  //   fromState: "Gujarat",
  //   toState: "Gujarat",
  //   distance: "160 km",
  //   duration: "2 hrs 30 min",
  //   price: "₹5,250",
  //   isAirport: false,
  //   description:
  //     "Book Rajkot to Gir National Park cab with Halo Sorath. Early morning safari drops and flexible wildlife tour packages with comfortable AC vehicles.",
  //   highlights: [
  //     "Safari-hour drop service",
  //     "Wildlife tour packages",
  //     "Experienced route drivers",
  //     "Round-trip available",
  //   ],
  //   popularFor:
  //     "Gir National Park is the last wild habitat of Asiatic lions. It attracts thousands of wildlife tourists from Rajkot every year.",
  //   seoTitle:
  //     "Rajkot to Gir Cab | Book Wildlife Safari Taxi | Halo Sorath",
  //   seoDescription:
  //     "Book Rajkot to Gir National Park cab at ₹5,250. 160 km, 2.5 hrs. Safari drop service available. Professional drivers. Halo Sorath Gujarat.",
  //   landmarks: ["Gir National Park", "Devaliya Safari Park", "Sasan Gir", "Kamleshwar Dam"],
  // },
  {
    slug: "ahmedabad-to-somnath-cab",
    from: "Ahmedabad",
    to: "Somnath",
    fromState: "Gujarat",
    toState: "Gujarat",
    distance: "400 km",
    duration: "6 hrs",
    price: "₹6,600",
    isAirport: false,
    description:
      "Book Ahmedabad to Somnath cab with Halo Sorath. Long-distance pilgrimage taxi with comfortable SUVs, experienced drivers, and complete transparency.",
    highlights: [
      "Long-distance specialists",
      "Spacious Innova & Ertiga",
      "Pit stops included",
      "Night travel available",
    ],
    popularFor:
      "Somnath is among the most visited pilgrimage sites from Ahmedabad. Many families and religious groups take this route to visit the first Jyotirlinga.",
    seoTitle:
      "Ahmedabad to Somnath Cab | Book Taxi ₹6,600 | Halo Sorath",
    seoDescription:
      "Book Ahmedabad to Somnath cab at ₹6,600. 400 km, 6 hrs. Long-distance pilgrimage taxi with spacious SUVs. Halo Sorath 24×7 support.",
    landmarks: ["Somnath Jyotirlinga", "Bhalka Tirth", "Prabhas Patan Museum", "Somnath Beach"],
  },
  {
    slug: "ahmedabad-to-dwarka-cab",
    from: "Ahmedabad",
    to: "Dwarka",
    fromState: "Gujarat",
    toState: "Gujarat",
    distance: "450 km",
    duration: "7 hrs",
    price: "₹7,425",
    isAirport: false,
    description:
      "Book Ahmedabad to Dwarka cab with Halo Sorath. Premium long-distance taxi for the Char Dham pilgrimage with experienced drivers and spacious vehicles.",
    highlights: [
      "Char Dham package available",
      "Premium SUVs & Tempo",
      "Driver halt facility",
      "24×7 booking",
    ],
    popularFor:
      "Dwarka is a major Char Dham pilgrimage destination from Ahmedabad. It's highly popular for family pilgrimage tours.",
    seoTitle:
      "Ahmedabad to Dwarka Cab | Book Taxi ₹7,425 | Halo Sorath",
    seoDescription:
      "Book Ahmedabad to Dwarka cab at ₹7,425. 450 km, 7 hrs. Char Dham pilgrimage taxi with premium vehicles. Halo Sorath Gujarat.",
    landmarks: ["Dwarkadheesh Temple", "Bet Dwarka", "Nageshwar", "Rukmini Devi Temple"],
  },
  {
    slug: "ahmedabad-to-diu-cab",
    from: "Ahmedabad",
    to: "Diu",
    fromState: "Gujarat",
    toState: "Diu (UT)",
    distance: "370 km",
    duration: "5 hrs 30 min",
    price: "₹6,105",
    isAirport: false,
    description:
      "Book Ahmedabad to Diu cab with Halo Sorath. Premium road trip taxi to Diu beaches with AC vehicles, experienced drivers, and best rates.",
    highlights: [
      "Beach road trip specialists",
      "Family & group packages",
      "Scenic NH51 route",
      "Return trips available",
    ],
    popularFor:
      "Diu is a top coastal getaway from Ahmedabad known for beaches, Portuguese architecture, and relaxed atmosphere.",
    seoTitle:
      "Ahmedabad to Diu Cab | Book Taxi ₹6,105 | Halo Sorath",
    seoDescription:
      "Book Ahmedabad to Diu cab at ₹6,105. 370 km, 5.5 hrs. Beach road trip taxi with family packages. Halo Sorath Gujarat.",
    landmarks: ["Diu Fort", "Nagoa Beach", "Chakratirth Beach", "St. Paul's Church"],
  },
  // {
  //   slug: "ahmedabad-to-gir-cab",
  //   from: "Ahmedabad",
  //   to: "Gir",
  //   fromState: "Gujarat",
  //   toState: "Gujarat",
  //   distance: "360 km",
  //   duration: "5 hrs",
  //   price: "₹6,600",
  //   isAirport: false,
  //   description:
  //     "Book Ahmedabad to Gir National Park cab with Halo Sorath. Wildlife tour taxi with spacious vehicles, early morning safari drops, and flexible packages.",
  //   highlights: [
  //     "Wildlife tour taxi",
  //     "Safari booking assistance",
  //     "Group vehicles available",
  //     "Hotel drop facility",
  //   ],
  //   popularFor:
  //     "Gir is the world's only habitat for wild Asiatic lions. It is among the most booked wildlife tour routes from Ahmedabad.",
  //   seoTitle:
  //     "Ahmedabad to Gir Cab | Wildlife Safari Taxi ₹6,600 | Halo Sorath",
  //   seoDescription:
  //     "Book Ahmedabad to Gir National Park cab at ₹4,000. 360 km, 5 hrs. Wildlife safari taxi. Safari drops available. Halo Sorath Gujarat.",
  //   landmarks: ["Gir National Park", "Sasan Gir", "Devaliya Safari", "Kamleshwar Dam"],
  // },
  {
    slug: "ahmedabad-airport-taxi",
    from: "Ahmedabad",
    to: "Sardar Vallabhbhai Patel International Airport",
    fromState: "Gujarat",
    toState: "Gujarat",
    distance: "City-wide",
    duration: "Varies",
    price: "₹600 onwards",
    isAirport: true,
    description:
      "Book Ahmedabad Airport taxi with Halo Sorath. Professional airport transfer from all Ahmedabad locations with flight tracking and guaranteed on-time service.",
    highlights: [
      "SVP International Airport",
      "Flight tracking & live updates",
      "Meet & greet service",
      "Fixed rates, no hidden charges",
    ],
    popularFor:
      "Sardar Vallabhbhai Patel International Airport is Gujarat's busiest airport. Halo Sorath provides trusted cab service to and from all Ahmedabad areas.",
    seoTitle:
      "Ahmedabad Airport Taxi | SVP Airport Cab | Halo Sorath",
    seoDescription:
      "Book Ahmedabad Airport taxi with Halo Sorath. Flight tracking, meet & greet, 24×7. Fixed rates from ₹600. Reliable SVP airport transfer service.",
    landmarks: ["SVP International Airport", "Navrangpura", "SG Highway", "Satellite Area"],
  },
  {
    slug: "somnath-to-diu-cab",
    from: "Somnath",
    to: "Diu",
    fromState: "Gujarat",
    toState: "Diu (UT)",
    distance: "90 km",
    duration: "1 hr 30 min",
    price: "₹5,250",
    isAirport: false,
    description:
      "Book Somnath to Diu cab with Halo Sorath. A popular coastal pilgrimage-to-beach combo route with scenic views and comfortable AC vehicles.",
    highlights: [
      "Pilgrimage to beach combo",
      "Scenic coastal highway",
      "Flexible timing",
      "On-demand service",
    ],
    popularFor:
      "Many pilgrims visiting Somnath extend their trip to Diu beaches. This short coastal cab ride is one of the most scenic routes in Gujarat.",
    seoTitle:
      "Somnath to Diu Cab | Book Taxi ₹5,250 | Halo Sorath",
    seoDescription:
      "Book Somnath to Diu cab at ₹5,250. 90 km, 1.5 hrs. Scenic coastal taxi. Pilgrimage-to-beach route. Professional drivers. Halo Sorath Gujarat.",
    landmarks: ["Diu Fort", "Nagoa Beach", "INS Khukri Memorial", "Ghoghla Beach"],
  },
  {
    slug: "somnath-to-dwarka-cab",
    from: "Somnath",
    to: "Dwarka",
    fromState: "Gujarat",
    toState: "Gujarat",
    distance: "235 km",
    duration: "4 hrs",
    price: "₹5,250",
    isAirport: false,
    description:
      "Book Somnath to Dwarka cab for the Jyotirlinga pilgrim trail. Travel between two of India's holiest sites with comfortable AC taxis and professional drivers.",
    highlights: [
      "Sacred pilgrimage corridor",
      "Stops at Nageshwar optional",
      "Driver wait service",
      "Group vehicles available",
    ],
    popularFor:
      "Somnath to Dwarka is a highly popular pilgrimage route covering two of India's most sacred Jyotirlinga shrines in a single day.",
    seoTitle:
      "Somnath to Dwarka Cab | Pilgrimage Taxi ₹5,250 | Halo Sorath",
    seoDescription:
      "Book Somnath to Dwarka cab at ₹5,250. 235 km, 4 hrs. Sacred pilgrimage taxi. Optional Nageshwar stop. Professional drivers. Halo Sorath.",
    landmarks: ["Dwarkadheesh Temple", "Nageshwar Jyotirlinga", "Bet Dwarka", "Rukmini Temple"],
  },
  {
    slug: "dwarka-to-diu-cab",
    from: "Dwarka",
    to: "Diu",
    fromState: "Gujarat",
    toState: "Diu (UT)",
    distance: "330 km",
    duration: "5 hrs",
    price: "₹5,445",
    isAirport: false,
    description:
      "Book Dwarka to Diu cab with Halo Sorath. A scenic long-distance coastal route connecting two of Gujarat's top destinations with comfortable AC taxis.",
    highlights: [
      "Coastal highway route",
      "Spacious SUV options",
      "Flexible halt points",
      "Best rates guaranteed",
    ],
    popularFor:
      "Many tourists combine a Dwarka pilgrimage with a Diu beach holiday. This is a popular end-to-end Gujarat coastal route.",
    seoTitle:
      "Dwarka to Diu Cab | Book Taxi ₹5,445 | Halo Sorath",
    seoDescription:
      "Book Dwarka to Diu cab at ₹5,445. 330 km, 5 hrs. Coastal Gujarat taxi. Spacious AC vehicles. One-way & return. Halo Sorath.",
    landmarks: ["Diu Fort", "Nagoa Beach", "Chakratirth Beach", "INS Khukri Memorial"],
  },
  // {
  //   slug: "gir-to-diu-cab",
  //   from: "Gir",
  //   to: "Diu",
  //   fromState: "Gujarat",
  //   toState: "Diu (UT)",
  //   distance: "115 km",
  //   duration: "2 hrs",
  //   price: "₹5,250",
  //   isAirport: false,
  //   description:
  //     "Book Gir to Diu cab with Halo Sorath. The perfect wildlife-to-beach combo. After your safari, head to Diu's pristine beaches in a comfortable AC taxi.",
  //   highlights: [
  //     "Wildlife to beach combo",
  //     "Post-safari taxi available",
  //     "Luggage-friendly vehicles",
  //     "Best coastal route",
  //   ],
  //   popularFor:
  //     "Tourists combine Gir safari and Diu beaches in a single Gujarat trip. This short cab ride is the perfect way to move between these two top destinations.",
  //   seoTitle:
  //     "Gir to Diu Cab | Safari to Beach Taxi ₹5,250 | Halo Sorath",
  //   seoDescription:
  //     "Book Gir to Diu cab at ₹5,250. 115 km, 2 hrs. Post-safari beach taxi. Luggage-friendly. One-way & return. Halo Sorath Gujarat.",
  //   landmarks: ["Diu Fort", "Nagoa Beach", "Ghoghla Beach", "St. Paul's Church"],
  // },
  {
    slug: "keshod-airport-taxi",
    from: "Keshod",
    to: "Keshod Airport",
    fromState: "Gujarat",
    toState: "Gujarat",
    distance: "City & region-wide",
    duration: "Varies",
    price: "₹400 onwards",
    isAirport: true,
    description:
      "Book Keshod Airport taxi with Halo Sorath. The most trusted airport transfer for Junagadh, Veraval, Somnath & Saurashtra region with 24×7 cab service.",
    highlights: [
      "Junagadh & Somnath pickups",
      "Flight tracking included",
      "24×7 available",
      "Fixed affordable rates",
    ],
    popularFor:
      "Keshod Airport (IXK) serves Junagadh and the Saurashtra region. Halo Sorath is the leading taxi provider for airport transfers to/from Keshod.",
    seoTitle:
      "Keshod Airport Taxi | Junagadh Airport Cab | Halo Sorath",
    seoDescription:
      "Book Keshod Airport taxi with Halo Sorath. Serves Junagadh, Somnath, Veraval. Flight tracking, 24×7, fixed rates from ₹400. Best Keshod airport cab.",
    landmarks: ["Keshod Airport (IXK)", "Junagadh City", "Veraval", "Somnath Temple"],
  },
];


// At the very bottom of routeData.js, replace the hook section with just this:

// ── Live price fetcher ─────────────────────────────────────────────────────
// In src/data/routeData.js - replace the fetchRoutePrice function with this:

export async function fetchRoutePrice(from, to, tripType = "one") {
  try {
    const today = new Date().toISOString().split("T")[0];
    const res = await fetch(
      `https://prashantbha.pythonanywhere.com/api/find-cabs/?pickup=${encodeURIComponent(from)}&drop=${encodeURIComponent(to)}&trip_type=${tripType}&date=${today}`
    );
    const data = await res.json();
    const cabs = data.cabs || [];
    if (!cabs.length) return null;

    // Use total_price (the final fare shown to customers)
    const minPrice = Math.min(...cabs.map(c => Number(c.total_price)).filter(p => p > 0));
    return minPrice ? `₹${Math.round(minPrice).toLocaleString("en-IN")}` : null;
  } catch {
    return null;
  }
}